import { useUser } from "@packsize/authentication";
import { useEffect } from "react";

import { applicationName } from "@/environment";

export const useSetupPageTitle = (): void => {
	const { currentUser, isPacksizeUser } = useUser();
	const isAuthenticated = Boolean(currentUser);

	useEffect(() => {
		if (!isAuthenticated) {
			return;
		}

		if (isPacksizeUser !== true) {
			document.title = applicationName;
			return;
		}

		const currentUrl = window.location.hostname;

		let environmentTitle;

		switch (true) {
			case currentUrl.includes("localhost"):
				environmentTitle = "Dev";
				break;
			case currentUrl.includes("preprod."):
				environmentTitle = "PreProd";
				break;
			case currentUrl.includes("prod1."):
			case currentUrl.includes("prod."):
				environmentTitle = "Prod";
				break;
			case currentUrl.includes("-stage."):
				environmentTitle = "Stage";
				break;
			case currentUrl.includes("prod-2."):
			case currentUrl.includes("prod2."):
				environmentTitle = "WM";
				break;
			default:
				environmentTitle = "Development";
				break;
		}

		document.title = `${environmentTitle} | PackNet`;
	}, [isAuthenticated, isPacksizeUser]);
};
